define('OutSystems/ClientRuntime/modules/ClientVariables/LocalStorageClientVariablesService',["require", "exports", "../../DataTypes", "../../Logger", "../../RegExpHelper", "../../RolesInfo", "../PubSub/Publisher", "../Storage/StorageNaming", "./LocalStorageSerializer"], function (require, exports, DataTypes_1, Logger, RegExpHelper_1, RolesInfo_1, Publisher_1, StorageNaming_1, LocalStorageSerializer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CLIENT_VARIABLES_MODULE_NAME = "Client Variables";
    var NULL_ARGUMENT_HANDLER_ERROR_MESSAGE = "Argument 'handler' cannot be null or undefined";
    var SESSION_USER_ID = "$SESSION_USER_ID";
    function isNullOrUndefined(value) {
        return value === undefined || value === null;
    }
    var LocalStorageClientVariablesService = (function () {
        function LocalStorageClientVariablesService(namespace) {
            this.namespace = namespace;
            this.fullKeyMatcher = null;
            this.publisher = new Publisher_1.default(CLIENT_VARIABLES_MODULE_NAME, namespace);
            this.fullKeyMatcher = new RegExp("^" + RegExpHelper_1.escape(StorageNaming_1.OS_STORAGE_PREFIX) + RegExpHelper_1.escape(this.namespace) + "\\$[^$]*\\$ClientVars\\$");
            this.checkSessionExpires();
            this.innerSetVariable(SESSION_USER_ID, "", DataTypes_1.DataTypes.Integer, RolesInfo_1.getUserId());
        }
        LocalStorageClientVariablesService.prototype.subscribe = function (handler, context) {
            return this.publisher.subscribe(handler, context);
        };
        LocalStorageClientVariablesService.prototype.unsubscribe = function (handler, context) {
            return this.publisher.unsubscribe(handler, context);
        };
        LocalStorageClientVariablesService.prototype.getFullKey = function (key, module) {
            return "" + StorageNaming_1.OS_STORAGE_PREFIX + this.namespace + "$" + module + "$ClientVars$" + key;
        };
        LocalStorageClientVariablesService.prototype.getVariable = function (key, module, type, defaultValue) {
            this.checkSessionExpires();
            return this.innerGetVariable(key, module, type, defaultValue);
        };
        LocalStorageClientVariablesService.prototype.innerGetVariable = function (key, module, type, defaultValue) {
            var savedValue = window.localStorage.getItem(this.getFullKey(key, module));
            Logger.trace(CLIENT_VARIABLES_MODULE_NAME, "Reading Client Variable " + key + " of module " + module + " for " + this.namespace);
            if (isNullOrUndefined(savedValue)) {
                return isNullOrUndefined(defaultValue) ? DataTypes_1.defaultForType(type) : defaultValue;
            }
            return LocalStorageSerializer_1.deserialize(savedValue, type);
        };
        LocalStorageClientVariablesService.prototype.setVariable = function (key, module, type, value) {
            this.checkSessionExpires();
            this.innerSetVariable(key, module, type, value);
            this.publisher.publish({ key: key, module: module, value: value });
        };
        LocalStorageClientVariablesService.prototype.innerSetVariable = function (key, module, type, value) {
            window.localStorage.setItem(this.getFullKey(key, module), LocalStorageSerializer_1.serialize(value, type));
            Logger.trace(CLIENT_VARIABLES_MODULE_NAME, "Set Client Variable " + key + " of module " + module + " for " + this.namespace);
        };
        LocalStorageClientVariablesService.prototype.removeAllVariables = function () {
            var allVariableKeys = [];
            for (var i = 0; i < window.localStorage.length; i++) {
                var key = window.localStorage.key(i);
                if (this.fullKeyMatcher.test(key)) {
                    allVariableKeys.push(key);
                }
            }
            if (allVariableKeys.length > 0) {
                for (var _i = 0, allVariableKeys_1 = allVariableKeys; _i < allVariableKeys_1.length; _i++) {
                    var key = allVariableKeys_1[_i];
                    window.localStorage.removeItem(key);
                }
                this.publisher.publish();
            }
        };
        LocalStorageClientVariablesService.prototype.checkSessionExpires = function () {
            var userId = this.innerGetVariable(SESSION_USER_ID, "", DataTypes_1.DataTypes.Integer);
            if (RolesInfo_1.getUserId() !== userId) {
                if (userId !== 0) {
                    Logger.trace(CLIENT_VARIABLES_MODULE_NAME, "Removing all Client Variables for user provider " + this.namespace);
                    this.removeAllVariables();
                }
                this.innerSetVariable(SESSION_USER_ID, "", DataTypes_1.DataTypes.Integer, RolesInfo_1.getUserId());
            }
        };
        return LocalStorageClientVariablesService;
    }());
    exports.default = LocalStorageClientVariablesService;
});
//# sourceMappingURL=LocalStorageClientVariablesService.js.map;
